import type { RefObject } from "react";
import { Icon } from "../../icons";

interface CommandPaletteSearchProps {
  inputRef: RefObject<HTMLInputElement | null>;
  listId: string;
  /** Id of the highlighted option, if any. */
  activeOptionId?: string;
  placeholder: string;
  query: string;
  onQueryChange: (query: string) => void;
}

/** The palette's search field: a combobox driving the results listbox. */
export function CommandPaletteSearch({ inputRef, listId, activeOptionId, placeholder, query, onQueryChange }: CommandPaletteSearchProps): React.JSX.Element {
  return (
    <div className="nb-palette-search">
      <Icon name="search" />
      <input
        ref={inputRef}
        type="text"
        role="combobox"
        aria-expanded="true"
        aria-controls={listId}
        aria-activedescendant={activeOptionId}
        aria-autocomplete="list"
        autoComplete="off"
        spellCheck={false}
        placeholder={placeholder}
        aria-label={placeholder}
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
      />
      <kbd className="nb-kbd">Esc</kbd>
    </div>
  );
}
